import { render } from "./GetStarted.vue?vue&type=template&id=a54690a2&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=a54690a2&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54690a2"]])

export default __exports__